import { useState } from 'react';
import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { listHeaderObj } from '../helpers/constant';

interface IProps {
  compartmentData: any;
  isView: boolean;
}

const THead = ({ compartmentData, isView }: IProps) => {
  return (
    <thead>
      <TableHeaderHtmlCustom tableHeaderObj={listHeaderObj} />
    </thead>
  );
};

export default THead;
